import { useCallback } from "react";
import { useCaMap, useCaMapEvents, useSelection } from "../../state";
import { Cube } from "../../state/types";
import { zoomTo } from "../util";
import { CustomControl } from "./CustomControl";

const base = "rounded-sm hover:bg-bright-yellow text-center py-1 px-2";
interface ButtonProps {
  name: string;
  zoom: number;
  callback?: (e) => void;
  active?: boolean;
}
const Button = ({ name, zoom, callback, active = false }: ButtonProps) => (
  <button
    data-zoom={zoom}
    onClick={callback}
    className={`${base}${active ? " bg-bright-yellow" : ""}`}
  >
    {name}
  </button>
);

// const levels = [10, 17];
export const MapViewControls = () => {
  const map = useCaMap();
  const [zoom] = useCaMapEvents("zoom");
  const feature: Cube = useSelection((s) => s?.state === "fetched" && s.cube);
  const setZoom = useCallback(
    (e) => {
      const zoom = parseInt(e.target.dataset.zoom);
      if (!(feature && zoom === 20)) return map.setZoom(zoom);
      zoomTo(map, feature.geometry);
    },
    [map, feature]
  );

  return (
    <CustomControl position="bottom-right" className="maplibregl-ctrl" first={true}>
      <div className="flex justify-center p-1 rounded-md bg-white font-Gilroy text-dark font-bold text-xs">
        <Button name="NL" active={zoom <= 10} zoom={8} callback={setZoom} />
        <Button name="Regio" active={zoom > 10 && zoom <= 16} zoom={15} callback={setZoom} />
        <Button name="Kavel" active={zoom > 16} zoom={20} callback={setZoom} />
      </div>
    </CustomControl>
  );
};
